export const PASSWORD_PROTECTED_FILE_TITLE = 'This file is password-protected.'
export const PASSWORD_PROTECTED_FILE_DESCRIPTION =
	'Enter its password to preview it, or download the original file.'
export const PASSWORD_PROTECTED_FILE_MESSAGE = `${PASSWORD_PROTECTED_FILE_TITLE} ${PASSWORD_PROTECTED_FILE_DESCRIPTION}`

export const isPasswordProtectedPdf = (error: unknown): boolean =>
	(error as { name?: string })?.name === 'PasswordException'

export const getFileRenderingError = (error: unknown): string =>
	isPasswordProtectedPdf(error)
		? (error as { code?: number })?.code === 2
			? 'Incorrect password. Please try again.'
			: PASSWORD_PROTECTED_FILE_MESSAGE
		: 'Unable to load document preview. You can still download the original file.'

export const shouldTryImagePreview = (error: unknown): boolean =>
	(error as { name?: string })?.name === 'InvalidPDFException'
